import React from 'react';

import { Ionicons} from '@expo/vector-icons';
import {  StyleSheet, TouchableOpacity, View } from 'react-native';

const ControlsAlt = ({
  paused,
  onPressPlay,
  onPressPause,
  color
}) => {
  const bcolor = color? color: '#4f9eb5';
  return(
    <View style={styles.container}>
      {!paused ? (
        <TouchableOpacity  style={[styles.playButton, {backgroundColor: bcolor}]} onPress={onPressPause}>
          <View>
            <Ionicons name='pause' size={40} color='#fff' />
          </View>
        </TouchableOpacity>
      ) : (
        <TouchableOpacity style={[styles.playButton, {backgroundColor: bcolor}]} onPress={onPressPlay}>
          <View >
            <Ionicons name='play' size={40} color='#fff' />
          </View>
        </TouchableOpacity>
      )}

    </View>
  );
};

export default ControlsAlt;

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 1,
    // paddingTop: 8,
  },
  playButton: {
    height: 60,
    width: 60,
    paddingLeft: 3,
    // borderWidth: 1,
    // borderColor: '#444',
    // borderRadius: 72 / 2,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#4f9eb5',
    borderRadius: 40,
  }
});
